// Environment Variables Configuration
export const ENV = {
  // Site Information
  SITE_NAME: process.env.REACT_APP_SITE_NAME || "RSE Web",
  REACT_APP_SITE_URL:
    process.env.REACT_APP_PUBLIC_SITE_URL || "https://billingecrpos.in",
  SITE_DESCRIPTION:
    process.env.REACT_APP_SITE_DESCRIPTION || "RSE Web - Modern Web Solutions",

  // Social Media
  TWITTER_HANDLE:
    process.env.REACT_APP_PUBLIC_TWITTER_USERNAME || "@yourtwitter",
  FACEBOOK_APP_ID: process.env.REACT_APP_PUBLIC_FACEBOOK_PAGE || "",

  // Analytics
  GA_MEASUREMENT_ID: process.env.REACT_APP_GA_MEASUREMENT_ID || "",
  GA_TRACKING_ID: process.env.REACT_APP_GA_TRACKING_ID || "", // Legacy support
  GTM_ID: process.env.REACT_APP_GTM_ID || "",
  SENTRY_DSN: process.env.REACT_APP_SENTRY_DSN || "",

  // API Endpoints
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL || "",

  // Feature Flags
  ENABLE_ANALYTICS: process.env.REACT_APP_ENABLE_ANALYTICS === "true",
  ENABLE_DEBUG: process.env.REACT_APP_NODE_ENV === "development",

  // Performance Settings
  IMAGE_QUALITY: parseInt(process.env.REACT_APP_IMAGE_QUALITY || "85", 10),
  LAZY_LOAD_OFFSET: parseInt(
    process.env.REACT_APP_LAZY_LOAD_OFFSET || "200",
    10,
  ),

  // Cache Settings (in seconds)
  BROWSER_CACHE_MAX_AGE: 60 * 60 * 24 * 7, // 1 week
  CDN_CACHE_MAX_AGE: 60 * 60 * 24 * 30, // 30 days
};

// Default SEO Configuration
export const SEO_CONFIG = {
  DEFAULT_IMAGE: "/images/og-image.jpg",
  DEFAULT_KEYWORDS: [
    "ECR Machines Delhi",
    "POS System India",
    "Retail Billing Solutions",
    "R S Enterprises POS",
    "Best ECR Machine Dealer",
  ],
  OPEN_GRAPH: {
    type: "website",
    locale: "en_US",
    site_name: ENV.SITE_NAME,
  },
  TWITTER: {
    handle: ENV.TWITTER_HANDLE,
    site: ENV.TWITTER_HANDLE,
    cardType: "summary_large_image",
  },
};

// Performance Configuration
export const PERF_CONFIG = {
  // Image Optimization
  IMAGE_SIZES: {
    xs: 320,
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1280,
    "2xl": 1536,
  },

  // Lazy Loading
  LAZY_LOAD_THRESHOLD: 0.1,

  // Preload Critical Assets
  PRELOAD_ASSETS: [
    "/fonts/your-font.woff2",
    "/css/critical.css",
    "/images/logo.svg",
  ],

  // Preconnect to external domains
  PRECONNECT_DOMAINS: [
    "https://www.google-analytics.com",
    "https://www.googletagmanager.com",
    "https://fonts.googleapis.com",
    "https://fonts.gstatic.com",
  ],
};

// Security Headers Configuration
export const SECURITY_HEADERS = [
  {
    key: "X-DNS-Prefetch-Control",
    value: "on",
  },
  {
    key: "Strict-Transport-Security",
    value: "max-age=63072000; includeSubDomains; preload",
  },
  {
    key: "X-XSS-Protection",
    value: "1; mode=block",
  },
  {
    key: "X-Frame-Options",
    value: "SAMEORIGIN",
  },
  {
    key: "X-Content-Type-Options",
    value: "nosniff",
  },
  {
    key: "Referrer-Policy",
    value: "origin-when-cross-origin",
  },
  {
    key: "Permissions-Policy",
    value: "camera=(), microphone=(), geolocation=()",
  },
];

// Cache Control Headers
export const CACHE_CONTROL = {
  // Static assets (JS, CSS, images, etc.)
  static: "public, max-age=31536000, immutable",

  // HTML pages
  html: "public, max-age=0, must-revalidate",

  // API responses
  api: "public, max-age=0, must-revalidate",

  // Service worker
  sw: "public, max-age=0, must-revalidate",
};
